import React from "react";
import { CheckIcon, GlobeIcon, LockIcon, FlameIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { images } from "../../data/content";
const SPOTS_TOTAL = 100;
const SPOTS_LEFT = 7;
const perks = ["Lifetime digital access", "Instant download", "No monthly subscription", "No recurring fees", "7-day guarantee"];
export function OfferSection() {
  const filled = (SPOTS_TOTAL - SPOTS_LEFT) / SPOTS_TOTAL * 100;
  return <section id="offer" className="w-full bg-cream px-4 py-16 sm:px-5 sm:py-24" data-id="element-186" data-mp="1pya0scw7tgm">
      <div className="mx-auto max-w-2xl" data-id="element-187" data-mp="3swsr1znzt8jc">
        <p className="text-center text-sm font-bold uppercase tracking-[0.14em] text-gold-600" data-id="element-188" data-mp="3sxkkp4y14w6z">Special launch offer</p>
        <h2 className="mt-3 text-center font-serif text-[30px] font-bold leading-tight text-ink sm:text-5xl" data-id="element-189" data-mp="3nzj36og954xm">
          Here’s everything I’m giving you <em className="text-gold-600" data-id="element-190" data-mp="3ex9pxqtlmxgj">today</em>
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl border-4 border-gold-500 bg-white shadow-[0_20px_50px_rgba(11,26,48,0.15)]" data-id="element-191" data-mp="3ez4erg7zr9pw">
          <div className="bg-navy-900 px-5 py-3 text-center text-sm font-extrabold uppercase tracking-wider text-gold-400" data-id="element-192" data-mp="1fih35unujiq0">
            Complete system · Launch price
          </div>
          <div className="p-5 sm:p-8" data-id="element-193" data-mp="15sxh6g4u78qx">
            <img src={images.mainMockup} alt="Complete Blepharoplasty Clinical Pathway bundle" className="mx-auto w-full max-w-md" data-id="element-194" data-mp="15tz53l6ybpq2" />

            <dl className="mt-6 divide-y divide-navy-100 border-y border-navy-100" data-id="element-195" data-mp="1tjbeal2a3xsd">
              <div className="flex items-center justify-between gap-4 py-3.5" data-id="element-196" data-mp="1yh33h7bjh5sv">
                <dt className="text-base font-semibold text-ink" data-id="element-197" data-mp="1kgsbu22enn6n">Clinical Pathway™ — 6 Premium Volumes</dt>
                <dd className="shrink-0 text-base text-muted line-through" data-id="element-198" data-mp="1oi42max0megf">$97</dd>
              </div>
              <div className="flex items-center justify-between gap-4 py-3.5" data-id="element-199" data-mp="91vlmouhirxp">
                <dt className="text-base font-semibold text-ink" data-id="element-200" data-mp="d4iduqv2ievf">5 Exclusive Bonuses</dt>
                <dd className="shrink-0 text-base text-muted line-through" data-id="element-201" data-mp="2frgp3sic6b92">$197</dd>
              </div>
              <div className="flex items-center justify-between gap-4 py-3.5" data-id="element-202" data-mp="2arkl3t9n2jti">
                <dt className="text-base font-bold uppercase text-ink" data-id="element-203" data-mp="260ug4h54kizc">Total value</dt>
                <dd className="shrink-0 text-lg font-bold text-danger line-through" data-id="element-204" data-mp="21211umi0kny4">$294</dd>
              </div>
            </dl>

            <div className="mt-6 text-center" data-id="element-205" data-mp="1x0pl76h4bd22">
              <p className="text-base font-medium text-muted" data-id="element-206" data-mp="1x1qub5ekpph5">But today, the complete system is only:</p>
              <p className="mt-1 font-serif text-[88px] font-extrabold leading-none text-navy-900 sm:text-[110px]" data-id="element-207" data-mp="1s3fp57z84359">
                <span className="align-top text-4xl sm:text-5xl" data-id="element-208" data-mp="1i36nhemgppih">$</span>27
              </p>
              <p className="mt-2 text-sm font-extrabold uppercase tracking-[0.16em] text-gold-600" data-id="element-209" data-mp="1i5jesie41c87">One-time payment · USD</p>
              <p className="mx-auto mt-3 flex max-w-sm items-center justify-center gap-2 rounded-xl bg-navy-100 px-4 py-2.5 text-sm font-semibold text-navy-900" data-id="element-210" data-mp="3cgoe5ai5z2hq">
                <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-211" data-mp="3kw44wj296l3y" />
                Currency is converted automatically to your local currency at checkout.
              </p>
            </div>

            <div className="mt-6 rounded-2xl border border-danger/30 bg-danger/5 p-4" data-id="element-212" data-mp="3tslgtoifyn0r">
              <p className="flex items-center justify-center gap-2 text-center text-[15px] font-bold text-danger" data-id="element-213" data-mp="2jfp3j3tr57k">
                <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-214" data-mp="321p4cp0amke0" />
                Only {SPOTS_LEFT} spots left at the promotional price
              </p>
              <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-danger/15" role="progressbar" aria-valuenow={filled} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-215" data-mp="3az957wu8ueo3">
                <div className="h-full rounded-full bg-danger" style={{
                width: `${filled}%`
              }} data-id="element-216" data-mp="q9a6mdz39hy5" />
              </div>
              <p className="mt-2 flex justify-between text-xs font-semibold text-ink/70" data-id="element-217" data-mp="vazfpo2r3ljl">
                <span data-id="element-218" data-mp="24638nggviazw">{SPOTS_TOTAL - SPOTS_LEFT}% claimed</span>
                <span data-id="element-219" data-mp="1z7s33hxm2mnh">Price goes up when full</span>
              </p>
            </div>

            <ul className="mt-6 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-220" data-mp="2d6rqyndauxil">
              {perks.map(p => <li key={p} className="flex items-center gap-2.5 text-[15px] font-medium text-ink" data-id="element-221" data-mp="286dgyzs51dhx">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-success" data-id="element-222" data-mp="2n3npq1dec59y">
                    <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-223" data-mp="2i4t9n76tcutj" />
                  </span>
                  {p}
                </li>)}
            </ul>

            <div className="mt-7" data-id="element-224" data-mp="2rwgton11j9kz">
              <CTAButton label="Get it now for $27" data-id="element-225" data-mp="2rxiiduazbul6" />
              <p className="mt-3 flex items-center justify-center gap-1.5 text-sm text-muted" data-id="element-226" data-mp="35uduxwqfw45z">
                <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-227" data-mp="30wvi3v9ax4sp" />
                Secure checkout · Instant digital access · 7-day guarantee
              </p>
            </div>

            <div className="mt-7" data-id="element-228" data-mp="3pgp27shr35ds">
              <Countdown data-id="element-229" data-mp="3pfnsbrch0oxn" />
            </div>
          </div>
        </div>

        <div className="mx-auto mt-8 max-w-xl space-y-2 text-center text-lg leading-relaxed text-ink/85" data-id="element-230" data-mp="3ak7v5dglgcx1">
          <p data-id="element-231" data-mp="3fhzxl1ev7hfh">I intentionally kept the price low because I want you to <strong data-id="element-232" data-mp="3fkm2suea9kuj">actually use the system</strong>.</p>
          <p className="text-muted" data-id="element-233" data-mp="31qcwmo9z9kqd">Print the worksheets. Work through the cases. Compare your reasoning. Return to the pathway whenever you review another case.</p>
        </div>
      </div>
    </section>;
}